import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
  Snackbar,
  Alert,
} from "@mui/material";
import { tokens } from "../components/Theme";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import UpdateCropFruitBloom from "../api/crop/UpdateCropFruitBloom";
import GetCropFruitBloom from "../api/crop/GetCropFruitBloom";
export default function BloomStateTable({ appCropId }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [fruitBlooms, setFruitBlooms] = useState([]);
  useEffect(() => {
    const fetchFruitBloom = async () => {
      if (appCropId) {
        try {
          const res = await GetCropFruitBloom({ appCropId });
          setFruitBlooms(res.fruitBlooms);
        } catch (error) {
          console.error("Error fetching fruit bloom data:", error);
        }
      }
    };

    fetchFruitBloom();
  }, [appCropId]);

  const handleChange = (index, key, value) => {
    const updated = [...fruitBlooms];
    updated[index][key] = value;
    setFruitBlooms(updated);
  };

  const handleAdd = () => {
    setFruitBlooms([...fruitBlooms, { bloomDate: "", bloomAmount: "" }]);
  };

  const handleDelete = (index) => {
    setFruitBlooms(fruitBlooms.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    const result = {
      appCropId,
      fruitBlooms,
    };

    try {
      const res = await UpdateCropFruitBloom(result);
      setSnackbarSeverity("success");
      setSnackbarMessage("บันทึกสำเร็จ");
      setOpenSnackbar(true);
    } catch (err) {
      setSnackbarSeverity("error");
      setSnackbarMessage("บันทึกไม่สำเร็จ");
      setOpenSnackbar(true);
    }

    // console.log("Result:");
    // console.log(result);
    // console.log(JSON.stringify(result, null, 2));
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Box p={2} maxWidth={isMobile ? "350px" : "none"}>
      <Box
        sx={{ backgroundColor: colors.greenAccent[300] }}
        display="flex"
        justifyContent="center"
      >
        <Typography
          p={isMobile ? 1 : 2}
          variant={isMobile ? "body" : "h6"}
          fontWeight="bold"
          color="#fff"
        >
          ข้อมูลชุดดอก
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table size="big">
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>#</strong>
              </TableCell>
              <TableCell
                sx={{
                  minWidth: isMobile ? "10px" : "none",
                  fontSize: isMobile ? "13px" : "none",
                }}
              >
                <strong>วันที่ตรวจชุดดอก</strong>
              </TableCell>
              <TableCell
                sx={{
                  minWidth: isMobile ? "10px" : "none",
                  fontSize: isMobile ? "13px" : "none",
                }}
              >
                <strong>จำนวน</strong>
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  minWidth: isMobile ? "10px" : "none",
                  fontSize: isMobile ? "13px" : "none",
                }}
              >
                <strong>ลบ</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fruitBlooms.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <TextField
                    sx={{
                      maxWidth: isMobile ? "120px" : "none",
                      fontSize: isMobile ? "13px" : "none",
                    }}
                    InputProps={{
                      sx: {
                        "& input": {
                          fontSize: isMobile ? "12px" : "14px",
                        },
                      },
                    }}
                    type="date"
                    size="small"
                    fullWidth
                    value={row.bloomDate}
                    onChange={(e) =>
                      handleChange(index, "bloomDate", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    value={row.bloomAmount}
                    onChange={(e) =>
                      handleChange(index, "bloomAmount", e.target.value)
                    }
                    sx={{
                      minWidth: isMobile ? "45px" : "none",
                      fontSize: isMobile ? "13px" : "none",
                    }}
                    InputProps={{
                      sx: {
                        "& input": {
                          fontSize: isMobile ? "11px" : "14px",
                        },
                      },
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton color="error" onClick={() => handleDelete(index)}>
                    <DeleteIcon sx={{ fontSize: isMobile ? "15px" : "20px" }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={4} align="center">
                <IconButton onClick={handleAdd}>
                  <AddIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box textAlign="center" mt={3}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.greenAccent[400] }}
          onClick={handleSave}
        >
          บันทึกข้อมูล
        </Button>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            justifyContent: "center",
            minWidth: "200px",
            textAlign: "center",
          },
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
